import {state} from "./state";
import {enableEmptyMapClick} from "./markers.js";

export function initMap({mapImage}) {
    const isMobile = window.innerWidth <= 768;

    const map = L.map("map-adventure", {
        crs: L.CRS.Simple,
        minZoom: isMobile ? -1.5 : -0.34,
        maxZoom: 1,
        zoomDelta: 0.25,
        zoomSnap: 0,
        maxBoundsViscosity: 1.0,
        doubleClickZoom: false
    });

    const bounds = [[0, 0], [760, 984]];

    const imageOverlay = L.imageOverlay(mapImage, bounds, {
        className: "map-parallax"
    }).addTo(map);

    map.fitBounds(bounds);
    map.setMaxBounds(bounds, {paddingTopLeft: [40, 40], paddingBottomRight: [40, 40]});

    map.on("move", () => {
        const el = imageOverlay.getElement();
        if (!el) return;
        const c = map.getCenter();
        el.style.backgroundPosition = `${50 + c.lng * 0.02}% ${50 + c.lat * 0.02}%`;
    });

    state.map = map;
    enableEmptyMapClick(state.map);

    return map;
}
